<template>
  <div class="container">
    <div class="content">
      <p class="heading horizontal-padding">
        <span>機種変更の時に便利！</span><br>
        <span class="siwa-gray">Apple ID連携</span> をご利用ください
      </p>
      <p class="horizontal-padding" style="margin-bottom: 0">
        Apple ID連携はお使いのApple IDと香の川製麺アプリのアカウントを連携することができる機能です。<br>
        事前にApple ID連携をしておくと、機種変更時の引き継ぎでデータを簡単に引き継ぐことができます。
      </p>
      <img :src="require('@/assets/img/siwa/siwa.png')" class="horizontal-padding" style="width: 100%" />
      <div v-if="!isLoggedIn">
        <template v-if="canSIWA">
          <img :src="require('@/assets/img/siwa/appleid_button.png')" class="horizontal-padding" style="width: 100%" @click="this.tapSIWA" />
        </template>
        <div v-else class="horizontal-padding">
          <div class="disabled-siwa">お使いのアプリ / OSでは<br>ご利用いただけません</div>
        </div>
        <p class="horizontal-padding" style="text-align: left; margin-top: 12px; color: #E03535; font-weight: bold">Apple ID連携は、アプリバージョン4.3.0以上、iOS13以降に対応しています。</p>
      </div>
      <span v-else>
        <div class="siwa-logged-in">
          <img :src="require('@/assets/img/siwa/icon-chain.png')" style="width: 16px; margin-right: 6px" />
          Apple ID連携済み
        </div>
        <div class="horizontal-padding">
          <button class="revoke" @click="this.tapRevokeUserSIWA">Apple ID連携を解除する</button>
        </div>
      </span>
      <p class="horizontal-padding" style="margin-top: 30px">
        <span style="font-weight: bold">●ご注意事項</span><br>
        ・Apple IDをお持ちでない方はご利用できません。<br>
        ・iOS13以降対応となります。<br>
        ・1つのアプリIDに対して、同時に連携できるApple IDは1つまでです。<br>
        ・機種変時にAppleでサインインでデータ引き継ぎができるのは、機種変更前に香の川製麺アプリとApple IDを連携している場合のみになります。<br>
        ・Apple IDを変更したい方は、接続しているApple IDを解除の上、連携し直してください。<br>
        ・ID連携をしないまま、引き継ぎページからサインインをしても引き継ぎはできません。新しいアプリIDとお手持ちのApple IDが連携されます。
      </p>
    </div>
    <template v-if="isAlert">
      <alert-primary-secondary
        :title="'Apple ID連携を<br>解除してよろしいですか？'"
        :primaryLabel="'解除する'"
        :secondaryLabel="'戻る'"
        @tapPrimary="() => executeRevoke()"
        @tapSecondary="() => closeConfirmAlert()"
      />
    </template>
    <template v-if="isCompleteAlert">
      <alert-primary-secondary
        :title="'連携を解除しました'"
        :secondaryLabel="'閉じる'"
        @tapSecondary="() => closeCompleteAlert()"
      />
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import APIClient, { ErrorCode } from '@/api/APIClient'
import DateFormatter from '../utils/DateFormatter'
import AlertPrimarySecondary from '@/components/Modal/AlertPrimarySecondary.vue'
import { FactoryTrack } from '@/constant/firebase'

export default {
  name: 'DataInheritInput',
  components: {
    AlertPrimarySecondary
  },
  data: function() {
    return {
      isLoggedIn: false,
      isAlert: false,
      isCompleteAlert: false,
      canSIWA: false
    }
  },
  async created() {
    document.title = 'Apple ID連携とは'

    const accTime = new DateFormatter().format(new Date())
    const params = {
      apiType: '12',
      acc_time: accTime
    }
    try {
      window.receivedToken = payload => {
        const json = JSON.parse(payload)
        this.fetchUserSIWA(json)
        window.receivedToken = null
      }
      this.actionRequestToken(params)
    } catch (e) {
      console.log(e)
    }

    try {
      window.receivedSIWAIdToken = async payload => {
        const json = JSON.parse(payload)
        this.actionToggleLoading(true)
        const res = await APIClient.postSIWA(json.app_token, json.acc_time, json.user_id, json.id_token, json.nonce)
        this.actionToggleLoading(false)
        let result = ''
        console.log(res)
        if (res.status === 200 && res.data.data.code === ErrorCode.CODE_SUCCESS) {
          this.isLoggedIn = true
        } else if (res.status === 200 && res.data.data.code === '4003000') {
          result = 'このApple IDはすでに別のアプリIDと連携されています。\n' +
            'アプリを再インストールして引き継ぎ画面より、Apple IDでアプリを開始してください。'
        } else {
          result = 'Apple ID連携に失敗しました'
        }
        this.actionLineLoginResult(result)
      }
    } catch (e) {
      console.log(e)
    }

    await this.actionCanSIWA()
    try {
      window.receivedCanSIWA = payload => {
        console.log('receivedCanSIWA: ', payload)
        this.canSIWA = payload === 'true'
      }
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Native', ['actionRequestToken', 'actionRequestSIWA', 'actionLineLoginResult', 'actionVer4_2', 'actionCanSIWA']),
    ...mapActions('Analytics', ['trackEvent']),
    async tapSIWA() {
      this.trackEvent(FactoryTrack.createSIWA())
      if (this.canSIWA) {
        await this.actionRequestSIWA()
      }
    },
    async tapRevokeUserSIWA() {
      this.trackEvent(FactoryTrack.createRevokeUserSIWAOpen())
      this.isAlert = true
    },
    async fetchUserSIWA(payload) {
      const token = payload.app_token
      const userId = payload.user_id
      const accTime = payload.acc_time
      const res = await APIClient.postFetchUserSIWA(token, accTime, userId)
      if (res.status === 200 && res.data.data.code === ErrorCode.CODE_SUCCESS && res.data.data.user_id.length > 0) {
        this.isLoggedIn = true
      }
    },
    async revokeUserSIWA(payload) {
      const token = payload.app_token
      const userId = payload.user_id
      const accTime = payload.acc_time
      this.actionToggleLoading(true)
      const res = await APIClient.postRevokeUserSIWA(token, accTime, userId)
      if (res.status === 200 && res.data.data.code === ErrorCode.CODE_SUCCESS) {
        this.isLoggedIn = false
        this.isCompleteAlert = true
      }
      this.actionToggleLoading(false)
    },
    executeRevoke() {
      this.trackEvent(FactoryTrack.createRevokeUserSIWA())
      this.isAlert = false
      const accTime = new DateFormatter().format(new Date())
      const params = {
        apiType: '12',
        acc_time: accTime
      }

      try {
        window.receivedToken = payload => {
          const json = JSON.parse(payload)
          this.revokeUserSIWA(json)
          window.receivedToken = null
        }
        this.actionRequestToken(params)
      } catch (e) {
        console.log(e)
      }
    },
    closeConfirmAlert() {
      this.trackEvent(FactoryTrack.createRevokeUserSIWAClose())
      this.isAlert = false
    },
    closeCompleteAlert() {
      this.trackEvent(FactoryTrack.createCompleteRevokeUserSIWAClose())
      this.isCompleteAlert = false
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  min-height: 100%;
  background-color: #ffffff;

  .content {
    padding: 30px 0;

    p {
      text-align: left;
      color: #333333;
      font-size: 14px;
      margin-bottom: 30px;
    }

    .heading {
      font-size: 16px;
      font-weight: bold;
      text-align: center;
    }

    .horizontal-padding {
      padding: 0 30px;
    }

    .siwa-logged-in {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
      background: #fceaea;
      color: #E03535;
      font-size: 16px;
      font-weight: bold;
    }

    .disabled-siwa {
      width: 100%;
      height: 46px;
      background: #AAAAAA;
      color: #FFFFFF;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;
      font-size: 90%;
      line-height: 1.25em;
    }
  }
}

.siwa-gray {
  color: #999999;
}

button.revoke {
  width: 100%;
  background: #001000;
  border-radius: 7px;
  border: none;
  font-size: 15px;
  font-weight: bold;
  color: #ffffff;
  padding: 13px 2px;
  margin-top: 20px;
}
</style>
